<nz-spin [nzSpinning]="loading$ | async" [nzDelay]="500">
    <ng-container *ngIf="appointment">
        <!-- ----------------------------------------------------------------------- -->
        <!--                                 Header                                  -->
        <!-- ----------------------------------------------------------------------- -->

        <nz-page-header class="site-page-header">
            <!--breadcrumb-->
            <nz-breadcrumb nz-page-header-breadcrumb>
                <!-- ! no need for breadcrumb in drawer -->
                <!-- <nz-breadcrumb-item>
                        <a
                            href="javascript:;"
                            (click)="goBack()"
                        >
                            <i
                                nz-icon
                                nzType="left"
                                nzTheme="outline"
                                style="margin-right: 10px"
                            ></i>
                        </a>
                        <a [routerLink]="['/crm/appointments']">
                            Appointments</a>
                    </nz-breadcrumb-item> -->

                <nz-breadcrumb-item
                    >ID: {{ appointment._id }}
                </nz-breadcrumb-item>
            </nz-breadcrumb>

            <!--title-->
            <nz-page-header-title
                *ngIf="
                    appointmentLead?.firstName + ' ' + appointmentLead?.lastName
                        | titlecase as leadName
                "
            >
                <!-- <a
                    *ngIf="!appointmentLead.isPatient"
                    nzPopconfirmPlacement="left"
                    nz-popconfirm
                    nzPopconfirmTitle="This lead does not have a patient record, create a patient from this lead?"
                    nzOkText="Create Patient"
                    nzCancelText="cancel"
                    (nzOnConfirm)="openCreatePatientDrawer()"
                >
                    {{ leadName }}
                </a> -->

                <a
                    [routerLink]="['/customers', appointmentLead?._id]"
                    [queryParams]="getOrgAwareMenuQueryParams()"
                    (click)="closeDrawer()"
                >
                    {{ leadName }}
                </a>
            </nz-page-header-title>

            <!--subtitle-->
            <nz-page-header-subtitle></nz-page-header-subtitle>

            <!-- status -->
            <!-- <nz-page-header-tags>
                    <nz-tag
                        [nzColor]="appointmentStatuses[appointment?.status]?.color"
                    >{{
                        appointment.status
                        }}</nz-tag>
                </nz-page-header-tags> -->

            <!--extra-->
            <nz-page-header-extra>
                <ng-container>
                    <div class="flex gap-4 items-center">
                        <!-- <button
                                *ngIf="!appointment.provider"
                                nz-button
                                nzType="dashed"
                                (click)="showAssignProvider()"
                                type="button"
                            >
                                Assign To Provider
                            </button> -->
                        <button
                            *ngIf="!!appointment?.extras?.emrId"
                            nz-button
                            nzType="dashed"
                            (click)="openEmr()"
                        >
                            Open In EMR
                        </button>
                        <button
                            *ngIf="!edit"
                            nz-button
                            nzType="dashed"
                            (click)="startEdit()"
                        >
                            Edit
                        </button>
                        <button
                            *ngIf="showSessionBtn"
                            nz-button
                            nzType="primary"
                            (click)="openSession(true)"
                        >
                            Session&nbsp;<i class="fa-solid fa-play"></i>
                        </button>
                        <button
                            *ngIf="edit"
                            nz-button
                            nzType="default"
                            [disabled]="loading$ | async"
                            (click)="cancelEdit()"
                        >
                            Cancel
                        </button>
                        <button
                            *ngIf="edit"
                            nz-button
                            nzType="primary"
                            [nzLoading]="loading$ | async"
                            (click)="save()"
                        >
                            Save
                        </button>
                    </div>
                </ng-container>
            </nz-page-header-extra>

            <!-- ----------------------------------------------------------------------- -->
            <!--                           Appointment Details                           -->
            <!-- ----------------------------------------------------------------------- -->

            <nz-page-header-content>
                <ng-container>
                    <form nz-form [formGroup]="editFG">
                        <nz-descriptions
                            nzSize="small"
                            [nzColumn]="{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1
                            }"
                            nzBordered
                        >
                            <nz-descriptions-item nzTitle="Status" [nzSpan]="1">
                                <ng-container *ngIf="!edit">
                                    <nz-tag
                                        [nzColor]="
                                            appointmentStatuses[
                                                appointment?.status
                                            ]?.color
                                        "
                                    >
                                        {{ appointment.status }}
                                    </nz-tag>
                                    <p
                                        class="mt-2"
                                        *ngIf="
                                            appointment.status === 'cancelled'
                                        "
                                    >
                                        <small>Cancellation Reason:</small>
                                        {{
                                            appointment.cancellationReason ||
                                                '-'
                                        }}
                                    </p>
                                </ng-container>

                                <nz-select
                                    *ngIf="edit"
                                    style="width: 100%"
                                    nzAllowClear
                                    formControlName="status"
                                >
                                    <nz-option
                                        *ngFor="
                                            let status of appointmentStatuses
                                                | keyvalue
                                        "
                                        [nzValue]="status.key"
                                        [nzLabel]="status.value['label']"
                                    >
                                    </nz-option>
                                </nz-select>
                            </nz-descriptions-item>
                            <!-- reservation -->
                            <nz-descriptions-item
                                nzTitle="Reservation"
                                [nzSpan]="1"
                            >
                                <span>
                                    {{
                                        appointment.reservation
                                            | date : 'EEEE, MMMM d @ h:mm a'
                                    }}
                                </span>
                                <!-- <nz-date-picker
                                    *ngIf="edit"
                                    style="width: 100%"
                                    nzFormat="EEEE, MMMM d h:mm a"
                                    [nzShowTime]="{ nzFormat: 'h:mm a' }"
                                    [nzAllowClear]="false"
                                    formControlName="reservation"
                                ></nz-date-picker> -->
                            </nz-descriptions-item>

                            <nz-descriptions-item
                                nzTitle="Service"
                                [nzSpan]="1"
                            >
                                <span *ngIf="!edit">
                                    {{ appointmentService?.label }}
                                    <br />
                                    {{ appointmentService?.description }}
                                </span>
                                <lookup
                                    *ngIf="edit"
                                    style="width: 100%; max-width: 260px"
                                    [type]="'services'"
                                    formControlName="service"
                                ></lookup>
                            </nz-descriptions-item>

                            <nz-descriptions-item
                                nzTitle="Schedule"
                                [nzSpan]="1"
                                >{{ appointmentSchedule?.label }}
                            </nz-descriptions-item>

                            <!-- <nz-descriptions-item
                                *ngIf="appointment?.provider?.name"
                                nzTitle="Provider:"
                                [nzSpan]="2"
                            >{{ appointment.provider.name }}
                            </nz-descriptions-item> -->

                            <!-- createdAt -->
                            <nz-descriptions-item
                                nzTitle="CreatedAt"
                                [nzSpan]="1"
                                >{{ appointment.createdAt | date : 'medium' }}
                            </nz-descriptions-item>
                        </nz-descriptions>
                    </form>
                </ng-container>

                <!--                  -->
                <!--  VIRTUAL MEETING -->
                <!--                  -->
                <ng-container *ngIf="appointment.virtualMeeting">
                    <nz-divider
                        nzText="Virtual Meeting"
                        nzOrientation="left"
                    ></nz-divider>
                    <nz-descriptions
                        nzSize="small"
                        nzLayout="vertical"
                        [nzColumn]="{
                            xxl: 1,
                            xl: 1,
                            lg: 1,
                            md: 1,
                            sm: 1,
                            xs: 1
                        }"
                    >
                        <nz-descriptions-item
                            *ngIf="appointment?.virtualMeeting?.hostUrl"
                        >
                            <a
                                nz-button
                                (click)="
                                    copyToClipboard(
                                        appointment?.virtualMeeting?.hostUrl
                                    )
                                "
                                ><i class="fa-solid fa-copy"></i>&nbsp;Host
                                Link</a
                            >
                            &nbsp;
                            <a
                                nz-button
                                (click)="
                                    copyToClipboard(
                                        appointment?.virtualMeeting?.joinUrl
                                    )
                                "
                                ><i class="fa-solid fa-copy"></i>&nbsp;Patient
                                Link</a
                            >
                        </nz-descriptions-item>
                    </nz-descriptions>
                </ng-container>

                <!--         -->
                <!-- EXTRAS -->
                <!--         -->
                <ng-container *ngIf="appointment.extras">
                    <nz-divider
                        nzText="Extras"
                        nzOrientation="left"
                    ></nz-divider>
                    <nz-descriptions
                        nzSize="small"
                        [nzColumn]="{
                            xxl: 1,
                            xl: 1,
                            lg: 1,
                            md: 1,
                            sm: 1,
                            xs: 1
                        }"
                    >
                        <nz-descriptions-item
                            *ngIf="appointment.duration"
                            nzTitle="Duration (min)"
                            [nzSpan]="1"
                            >{{ appointment.duration }}
                        </nz-descriptions-item>
                        <nz-descriptions-item
                            *ngIf="appointment.extras.inputHealthServiceId"
                            nzTitle="Service Id"
                            [nzSpan]="1"
                            >{{ appointment.extras.inputHealthServiceId }}
                        </nz-descriptions-item>
                        <nz-descriptions-item
                            *ngIf="appointment.extras.primaryIssueId"
                            nzTitle="Primary Issue Id"
                            [nzSpan]="1"
                            >{{ appointment.extras.primaryIssueId }}
                        </nz-descriptions-item>
                        <nz-descriptions-item
                            *ngIf="appointment.extras.providerId"
                            nzTitle="Provider Id"
                            [nzSpan]="1"
                            >{{ appointment.extras.providerId }}
                        </nz-descriptions-item>
                        <nz-descriptions-item
                            *ngIf="appointment.extras.providerName"
                            nzTitle="Provider Name"
                            [nzSpan]="1"
                            >{{ appointment.extras.providerName }}
                        </nz-descriptions-item>

                        <nz-descriptions-item
                            *ngIf="appointment.extras.communicationMethodName"
                            nzTitle="Communication Method"
                            [nzSpan]="1"
                            >{{ appointment.extras.communicationMethodName }}
                        </nz-descriptions-item>
                        <nz-descriptions-item
                            *ngIf="
                                appointment.extras.receiveMarketing != undefined
                            "
                            nzTitle="Receive Marketing"
                            [nzSpan]="1"
                            >{{ appointment.extras.receiveMarketing }}
                        </nz-descriptions-item>
                        <nz-descriptions-item
                            *ngIf="
                                appointment.extras.paymentStatus != undefined
                            "
                            nzTitle="Payment Status"
                            [nzSpan]="1"
                        >
                            <!-- For Legacy Support -->
                            {{ appointment.extras.paymentStatus }}
                        </nz-descriptions-item>
                        <nz-descriptions-item
                            *ngIf="appointment.payment?.message"
                            nzTitle="Payment Status"
                            [nzSpan]="1"
                            >{{ appointment.payment?.message }}
                        </nz-descriptions-item>
                        <nz-descriptions-item
                            *ngIf="appointment.extras.zoomMeeting"
                            nzTitle="Zoom Meeting"
                            [nzSpan]="1"
                        >
                            <div>
                                <p>
                                    Start URL (for doctor use):
                                    <a
                                        [href]="
                                            appointment.extras.zoomMeeting
                                                .startUrl
                                        "
                                        >{{
                                            appointment.extras.zoomMeeting
                                                .startUrl
                                        }}</a
                                    >
                                </p>
                                <p>
                                    Join URL (for patient use):
                                    <a
                                        [href]="
                                            appointment.extras.zoomMeeting
                                                .joinUrl
                                        "
                                        >{{
                                            appointment.extras.zoomMeeting
                                                .joinUrl
                                        }}</a
                                    >
                                </p>
                            </div>
                        </nz-descriptions-item>

                        <nz-descriptions-item
                            *ngIf="appointment.extras.dependents?.length > 0"
                            nzTitle="Dependents"
                            [nzSpan]="1"
                        >
                            <table>
                                <tr
                                    *ngFor="
                                        let dep of appointment.extras.dependents
                                    "
                                >
                                    <td *ngFor="let key of getKeys(dep)">
                                        <strong>{{ displayKey(key) }}:</strong>
                                        {{ dep[key] }}
                                        <hr />
                                    </td>
                                </tr>
                            </table>
                        </nz-descriptions-item>
                    </nz-descriptions>
                </ng-container>
            </nz-page-header-content>
        </nz-page-header>
    </ng-container>
</nz-spin>
